export class TemplateFileTo {
    name : string
    sourceFilename: string;
    destinationFilename: string;
    defaultTemplate: boolean;
    file: File;

    constructor(object?: any) {
        this.name = object?.name;
        this.sourceFilename = object?.sourceFilename;
        this.destinationFilename = object?.destinationFilename;
        this.defaultTemplate = object?.defaultTemplate;
    }

    toJSON() {
        return {
            name: this.name,
            sourceFilename: this.sourceFilename,
            destinationFilename: this.destinationFilename,
            defaultTemplate: this.defaultTemplate
        };
    }

}
